import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';

import { useSelector } from 'react-redux';

import { getCountdownStartTime } from '../../features/broadcast/selectors';

interface CountdownProps {
    onEnd(): void;
}

const Countdown: FunctionComponent<CountdownProps> = ({ onEnd }) => {
    const startTime = Math.floor((useSelector(getCountdownStartTime) as number) / 1000);

    const [time, setTime] = useState(startTime);
    const timerRef = useRef<ReturnType<typeof setInterval>>();
    const mountTimeRef = useRef<number>(0);

    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    const updateTime = useCallback(() => {
        const seconds = Math.floor((Date.now() - mountTimeRef.current) / 1000);
        const time = startTime - seconds;
        if (time <= 0 && timerRef.current) {
            clearInterval(timerRef.current);
            setTime(0);
            onEnd();
        } else {
            setTime(time);
        }
    }, [startTime, onEnd]);

    useEffect(() => {
        if (startTime > 0) {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
            timerRef.current = setInterval(updateTime, 1000);
            mountTimeRef.current = Date.now();
        }
    }, [startTime, updateTime]);

    useEffect(
        () => () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        },
        []
    );

    return (
        <>{`${String(hours).padStart(2, '0')}:${String(minutes).padStart(
            2,
            '0'
        )}:${String(seconds).padStart(2, '0')}`}</>
    );
};

export default Countdown;
